import React, { useState, useEffect } from 'react';

const NsfwToggle = () => {
  // Default to NSFW unless user explicitly saved SFW.
  const [isNsfw, setIsNsfw] = useState(() => {
    const saved = localStorage.getItem('nsfw_mode');
    if (saved === 'false') return false;
    if (saved === 'true') return true;
    return true;
  });

  useEffect(() => {
    // Apply mode and notify listeners (e.g., roster links) immediately.
    if (isNsfw) {
      document.body.classList.add('nsfw-mode');
      document.body.classList.remove('sfw-mode');
    } else {
      document.body.classList.add('sfw-mode');
      document.body.classList.remove('nsfw-mode');
    }
    
    localStorage.setItem('nsfw_mode', isNsfw ? 'true' : 'false');
    window.dispatchEvent(new CustomEvent('nsfw-mode-changed', { detail: isNsfw }));
  }, [isNsfw]);

  const toggleNsfw = () => {
    setIsNsfw(!isNsfw);
  };

  return (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        marginRight: '8px'
      }}
    >
      <button
        type="button"
        onClick={toggleNsfw}
        role="switch"
        aria-checked={isNsfw}
        title={isNsfw ? 'Currently NSFW mode. Click to switch to SFW.' : 'Currently SFW mode. Click to switch to NSFW.'}
        style={{
          position: 'relative',
          width: '104px',
          height: '30px',
          border: '1px solid var(--border-color)',
          borderRadius: '999px',
          cursor: 'pointer',
          background: 'var(--tile)',
          color: 'var(--text-secondary)',
          padding: '0 9px',
          transition: 'all 0.2s ease',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          fontSize: '11px',
          fontFamily: 'var(--font-mono)',
          fontWeight: 600
        }}
      >
        <span style={{ opacity: isNsfw ? 1 : 0.5, zIndex: 2 }}>NSFW</span>
        <span style={{ opacity: isNsfw ? 0.5 : 1, zIndex: 2 }}>SFW</span>
        <span
          aria-hidden="true"
          style={{
            position: 'absolute',
            top: '3px',
            left: isNsfw ? '3px' : '51px',
            width: '50px',
            height: '24px',
            borderRadius: '999px',
            backgroundColor: isNsfw ? 'var(--amber)' : 'var(--cyan)',
            boxShadow: '0 2px 6px rgba(0,0,0,0.3)',
            transition: 'left 0.2s ease, background-color 0.2s ease'
          }}
        />
      </button>
    </div>
  );
};

export default NsfwToggle;